import { InternalAxiosRequestConfig } from 'axios';
import { getActiveWorkspaceId } from '@/lib/workspace-context/workspace-context-bindings';

/**
 * Injects the current workspace id into outbound HTTP requests. Reads
 * the id from the workspace-context binding seam (configured at app
 * boot in `main.tsx`) so this lib-tier interceptor has no static
 * dependency on `@/entities/workspace`.
 */
export const workspaceIdRequestInterceptor = (config: InternalAxiosRequestConfig) => {
  // An explicit per-request header (e.g. the headless PDF render, which supplies
  // the workspace from the URL rather than the store) must win over the store.
  if (config.headers['x-selected-workspace-id']) {
    return config;
  }
  const workspaceId = getActiveWorkspaceId();
  if (workspaceId) {
    config.headers['x-selected-workspace-id'] = workspaceId;
  }
  return config;
};
